import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import './About.css'

function About() {
  return (
    <>
      <Navbar />
      
      <main className="about-page">
        <div className="container">
          
          {/* Hero Section */}
          <div className="about-hero">
            <h1>درباره <span className="accent">چکیده‌سرا</span></h1>
            <p className="hero-tagline">
              جایی که خواندن خلاصه‌های انگلیسی، یک تجربه روان و حرفه‌ای می‌شود.
            </p>
          </div>

          {/* Mission Section */}
          <div className="mission-section">
            <div className="mission-content">
              <h2>ماموریت ما</h2>
              <p>
                در دنیای پرشتاب امروز، زمان ارزشمندترین دارایی ماست. اما مطالعه کتاب‌های 
                انگلیسی به زبان اصلی، برای بسیاری از ما یک چالش بزرگ است: کلماتی که نمی‌فهمیم، 
                جملاتی که تمرکزمان را می‌شکنند، و ترجمه‌های مکرر که لذت مطالعه را از بین می‌برند.
              </p>
              <p>
                <strong className="accent">چکیده‌سرا</strong> برای حل همین مشکل متولد شد. ما می‌خواستیم 
                خواننده بتواند بدون توقف، بدون خروج از متن، و بدون اتلاف انرژی، هم خلاصه کتاب را 
                بخواند، هم ترجمه کلمات را در لحظه ببیند.
              </p>
            </div>
          </div>

          {/* What We Offer */}
          <div className="offer-section">
            <h2>چی پیشنهاد می‌دهیم؟</h2>
            <div className="offer-grid">
              <div className="offer-card">
                <div className="offer-icon">📚</div>
                <h3>خلاصه‌های حرفه‌ای</h3>
                <p>خلاصه کتاب‌های پرفروش انگلیسی در حوزه‌های مدیریت، روانشناسی، بیزینس و توسعه فردی</p>
              </div>
              <div className="offer-card">
                <div className="offer-icon">⚡</div>
                <h3>ترجمه لحظه‌ای</h3>
                <p>با انتخاب هر کلمه یا عبارت، ترجمه فارسی فوری در همان صفحه ظاهر می‌شود</p>
              </div>
              <div className="offer-card">
                <div className="offer-icon">🎯</div>
                <h3>بدون قطع تمرکز</h3>
                <p>نیاز به خروج از صفحه، باز کردن دیکشنری یا اپلیکیشن جداگانه ندارید</p>
              </div>
              <div className="offer-card">
                <div className="offer-icon">💡</div>
                <h3>تقویت واژگان</h3>
                <p>با هر بار مطالعه، دایره لغات انگلیسی شما بدون احساس خستگی گسترش می‌یابد</p>
              </div>
            </div>
          </div>

          {/* Who Is This For */}
          <div className="audience-section">
            <h2>این فضا برای چه کسانی است؟</h2>
            <div className="audience-grid">
              <div className="audience-item">
                <span className="audience-emoji">🎓</span>
                <span>دانشجویان</span>
              </div>
              <div className="audience-item">
                <span className="audience-emoji">👩‍🏫</span>
                <span>مدرسان زبان</span>
              </div>
              <div className="audience-item">
                <span className="audience-emoji">💼</span>
                <span>مدیران و متخصصان</span>
              </div>
              <div className="audience-item">
                <span className="audience-emoji">📖</span>
                <span>علاقه‌مندان به مطالعه</span>
              </div>
              <div className="audience-item">
                <span className="audience-emoji">🌍</span>
                <span>هر کسی که می‌خواهد انگلیسی کاربردی یاد بگیرد</span>
              </div>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="why-section">
            <h2>چرا چکیده‌سرا؟</h2>
            <div className="why-grid">
              <div className="why-item">
                <div className="why-number">۱</div>
                <h3>طراحی مینیمال و بی‌حاشیه</h3>
                <p>بدون تبلیغ، بدون منوهای شلوغ، فقط تو و متن</p>
              </div>
              <div className="why-item">
                <div className="why-number">۲</div>
                <h3>ترجمه حرفه‌ای و دقیق</h3>
                <p>کتاب‌های داستانی و غیرداستانی با حفظ ساختار و مفاهیم اصلی</p>
              </div>
              <div className="why-item">
                <div className="why-number">۳</div>
                <h3>بدون نیاز به نصب</h3>
                <p>کاملاً تحت وب، روی دسکتاپ، تبلت و موبایل</p>
              </div>
              <div className="why-item">
                <div className="why-number">۴</div>
                <h3>مناسب برای سطوح مختلف</h3>
                <p>از A1 تا C2، هر کس به اندازه خودش می‌تواند استفاده کند</p>
              </div>
            </div>
          </div>

          {/* Vision Section */}
          <div className="vision-section">
            <div className="vision-quote">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#e11d48" strokeWidth="1.5">
                <path d="M10 11h-4v-4h4v4zm8 0h-4v-4h4v4zm-8 8h-4v-4h4v4zm8 0h-4v-4h4v4z"/>
              </svg>
              <p>
                چکیده‌سرا فقط یک وبسایت نیست. یک روش جدید برای مطالعه است. 
                روشی که در آن دیگر خواننده منفعل نیستی. با هر انتخاب متن، 
                فهم و واژگان تو یک قدم جلوتر می‌رود.
              </p>
              <div className="vision-author">— تیم چکیده‌سرا</div>
            </div>
          </div>

          {/* Final CTA */}
          <div className="about-cta">
            <p>همین حالا سفر خواندن بی‌وقفه را شروع کن.</p>
            <a href="/summary-books" className="cta-about-btn">مشاهده خلاصه‌ها</a>
          </div>

        </div>
      </main>

      <Footer />
    </>
  )
}

export default About